<!--Mobile View-->
<!-- <div class="col hide-gt-sm mobile-view">
	<button mat-menu-item class="link" [routerLink]="''" [routerLinkActive]="'selected'"
		[routerLinkActiveOptions]="{ exact: true }" (click)="removeStorePage()"> Home </button> -->
<!-- <button mat-menu-item class="link" [routerLink]="'/collection'" [routerLinkActive]="'selected'"> Collection
	</button> -->
<!-- <button mat-menu-item class="link" [routerLink]="'/store'" [routerLinkActive]="'selected'"> Store
	</button>
	<button mat-menu-item class="link" [routerLink]="'/studio'" [routerLinkActive]="'selected'"> Studio </button>
	<button mat-menu-item class="link" (click)="menus['menuOccassion']=!menus['menuOccassion']">
		Occasions
		<mat-icon *ngIf="!menus['menuOccassion']" svgIcon="chev-right-menu" class="pull-right"></mat-icon>
		<mat-icon *ngIf="menus['menuOccassion']" svgIcon="chev-down" class=" pull-right"></mat-icon>
	</button>
	<div *ngIf="menus['menuOccassion']" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
		<button mat-menu-item *ngFor="let item of occasions"
			(click)="navigate('occasions', item.id)">{{item.name}}</button>
	</div>
	<button mat-menu-item class="link" (click)="menus['menuJewellery']=!menus['menuJewellery']">
		Jewellery
		<mat-icon *ngIf="!menus['menuJewellery']" svgIcon="chev-right-menu" class="pull-right"></mat-icon>
		<mat-icon *ngIf="menus['menuJewellery']" svgIcon="chev-down" class="pull-right"></mat-icon>
	</button>
	<div *ngIf="menus['menuJewellery']" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
		<ng-container *ngFor="let menuItem of jMenuOptions">
			<button class="link" mat-menu-item (click)="menus[menuItem.key]=!menus[menuItem.key]">{{menuItem.title}}
				<mat-icon *ngIf="!menus[menuItem.key]" svgIcon="chev-right-menu" class="pull-right"></mat-icon>
				<mat-icon *ngIf="menus[menuItem.key]" svgIcon="chev-down" class="pull-right"></mat-icon>
			</button>
			<div *ngIf="menus[menuItem.key]" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
				<button mat-menu-item *ngFor="let submenu of menuItem.options"
					(click)="navigate(menuItem.key, submenu.id ,  submenu)">{{submenu.name}}</button>
			</div>
		</ng-container>
	</div> -->

<!--For footer items-->
<!-- <ng-container *ngFor="let item of footerConfig">
		<button class="link" mat-menu-item (click)="menus[item.key]=!menus[item.key]">{{item.label}}
			<mat-icon *ngIf="!menus[item.key]" svgIcon="chev-right-menu" class="pull-right"></mat-icon>
			<mat-icon *ngIf="menus[item.key]" svgIcon="chev-down" class="pull-right"></mat-icon>
		</button>
		<div *ngIf="menus[item.key]" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
			<button mat-menu-item *ngFor="let submenu of item.options"
				[routerLink]="[submenu.route]">{{submenu.value}}</button>
		</div>
	</ng-container>
</div> -->

<div class="header_mobile hide-gt-sm" [ngClass]="{ 'hidden': !isMobileMenuVisible }">
	<div class="header_info">
		<div class="mobile_menu" (click)="removeStorePage()" [routerLinkActiveOptions]="{ exact: true }"
			[routerLinkActive]="'selected'" [routerLink]="''">
			<mat-icon class="icon-size-24" svgIcon="mobile-home"></mat-icon>
			<p>home</p>
		</div>
		<div class="mobile_menu" [routerLinkActive]="'selected'" [routerLink]="['/store']">
			<mat-icon class="icon-size-24" svgIcon="mobile-store"></mat-icon>
			<p>store</p>
		</div>
		<!-- <div class="mobile_menu" [routerLinkActive]="'selected'" [routerLink]="['/studio']">
			<mat-icon class="icon-size-24" svgIcon="mobile-studio"></mat-icon>
			<p>studio</p>
		</div> -->
		<div class="mobile_menu" [routerLinkActive]="'selected'" [routerLink]="['/collection']">
			<mat-icon class="icon-size-24" svgIcon="mobile-collection"></mat-icon>
			<p>collection</p>
		</div>
		<div class="mobile_menu" [routerLinkActive]="'selected'" [routerLink]="['/account']">
			<mat-icon class="icon-size-24" svgIcon="mobile-profile"></mat-icon>
			<p>profile</p>
		</div>
	</div>
</div>

<!--Desktop View-->
<div class="show-gt-sm desktop-view">
	<a mat-button class="link" [routerLink]="'/'" [routerLinkActive]="'selected'"
		[routerLinkActiveOptions]="{ exact: true }" (click)="removeStorePage()"> Home </a>
	<!-- <a mat-button class="link" [routerLink]="'/collection'" [routerLinkActive]="'selected'"
		[routerLinkActiveOptions]="{ exact: true }"> Collection </a> -->

	<div class="dropdown menuJewellery">
		<!-- <a mat-button class="link" type="button" data-toggle="dropdown">Jewellery</a> -->
		<div mat-button class="link" type="button" data-toggle="dropdown">Jewellery</div>
		<div class="dropdown-menu">
			<div *ngFor="let menuItem of jMenuOptions" class="menu-rows">
				<!-- <a (click)="menus[menuItem.key]=!menus[menuItem.key]">{{menuItem.title}}</a> -->
				<div class="jewelleryTitle" *ngIf="menuItem.options.length > 0"
					(click)="menus[menuItem.key]=!menus[menuItem.key]">{{menuItem.title}}</div>
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
					<button mat-menu-item *ngFor="let submenu of menuItem.options"
						(click)="navigate(menuItem.key,JewelleryName(submenu.name , menuItem.key), submenu.id, submenu)">{{submenu.name}}</button>
				</div>
			</div>
		</div>
	</div>

	<a mat-button class="link" [routerLink]="'/store'" [routerLinkActive]="'selected'"
		[routerLinkActiveOptions]="{ exact: true }"> Store </a>
	<!-- <a mat-button class="link" [routerLink]="'/studio'" [routerLinkActive]="'selected'"
		[routerLinkActiveOptions]="{ exact: true }"> Studio </a> -->

	<mat-menu></mat-menu> <!--do not delete this-->
	<div class="dropdown menuOccassion">
		<!-- <a mat-button class="link" type="button" data-toggle="dropdown">Occasions</a> -->
		<div class="link" mat-button type="button" data-toggle="dropdown">Occasions</div>
		<div class="dropdown-menu">
			<div class="menu-rows">
				<button mat-menu-item *ngFor="let item of occasions"
					(click)="navigate('occasions', occasionsName(item.name),item.id)">{{item.name}}</button>
			</div>
		</div>
	</div>

	<div class="dropdown menuOthers">
		<!-- <a mat-button class="link" type="button" data-toggle="dropdown">Others</a> -->
		<div mat-button class="link" type="button" data-toggle="dropdown">Others</div>
		<div class="dropdown-menu">
			<div *ngFor="let menuItem of others" class="menu-rows">
				<!-- <a (click)="menus[menuItem.key]=!menus[menuItem.key]">{{menuItem.title}}</a> -->
				<div class="jewelleryTitle" *ngIf="menuItem.options.length > 0"
					(click)="menus[menuItem.key]=!menus[menuItem.key]">{{menuItem.title}}</div>
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
					<button mat-menu-item *ngFor="let submenu of menuItem.options"
						(click)="navigate(menuItem.key,JewelleryName(submenu.name , menuItem.key) ,submenu.id, submenu)">{{submenu.name}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- <a mat-button class="link" [routerLink]="'/studio'" [routerLinkActive]="'selected'"
		[routerLinkActiveOptions]="{ exact: true }"> Blogs </a> -->
</div>